
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class KnowledgeBase extends Vue {

}
